import { createFileRoute } from "@tanstack/react-router";
import { QueueIndexPage } from "@/features/admin/queue/queue-index-page";

export const Route = createFileRoute("/admin/queue/")({
  component: RouteComponent,
});

function RouteComponent() {
  return <QueueIndexPage />;
}
